<template>
  <div class="spark-card day-placeholder-card loader-card">
    <div class="day-placeholder-eyebrow">{{ date }}</div>
    <div class="day-placeholder-title">{{ localize('spark.disabled.title') }}</div>
    <div class="day-placeholder-hint">
      {{ localize('spark.disabled.subtitle_empty') }}
    </div>
    <div class="day-placeholder-subtitle">
      <GamButton :variant="GamButtonVariant.STEKLO" :size="GamButtonSize.SMALL" @click="onClickAvailabilities">
        {{ localize('spark.disabled.update') }}
      </GamButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { localize } from '@/core/gambits';
import GamButton from '@/views/components/GamButton.vue';
import { GamButtonSize, GamButtonVariant } from '@/views/composables/constants/components/gamButton.constants';

interface DisabledProps {
  date: string;
  onClickAvailabilities: () => void;
}

defineProps<DisabledProps>();
</script>

<style lang="scss" scoped>
.day-placeholder-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  text-align: center;
  padding: 2rem;
  border-radius: var(--radius-normal);
  background: radial-gradient(circle at 20% 15%, var(--color-white-10), transparent 50%),
    radial-gradient(circle at 80% 85%, var(--color-pink-20), transparent 55%), var(--color-card-surface);
}

.day-placeholder-eyebrow {
  font-size: 11px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: var(--color-white-50);
}

.day-placeholder-title {
  font-size: 22px;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: var(--color-white-100);
}

.day-placeholder-subtitle {
  font-size: 13px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: var(--color-white-40);
}

.day-placeholder-eyebrow {
  color: var(--color-white);
  margin-bottom: 0.5rem;
}

.day-placeholder-hint {
  font-size: 13px;
  letter-spacing: 0.02em;
  color: var(--color-white-50);
  max-width: 220px;
}

.day-placeholder-subtitle {
  margin-top: 2rem;
}
</style>
